import React, { useEffect, useState } from "react";
import { Container } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "./translations.css";
import Loading from "../../components/ui/loader/loader";
import { useDispatch } from "react-redux";
import { getSignedUrl, recentTranslationsAction } from "../../redux/actions/translateAction";
import { availableLanguages } from "../../components/data/language";
import errorToast from "../../components/toast/errorToast";
import Pagination from '../../components/ui/pagination/pagination'
import downloadIcon from "../../assets/icons/downloads.png";
import previewIcon from "../../assets/icons/file.png";
import TranslationLayout from "../../components/ui/layouts/translate-layout";
import GoogleDrivePicker from "../../components/buttons/googleDrive";
import { ImGoogleDrive } from "react-icons/im";
import successToast from "../../components/toast/successToast";
import { Tooltip } from "react-tooltip";
import LoaderModal from "../../components/ui/Modal/loaderModal";
import moment from 'moment'
import { saveAs } from 'file-saver';
import { useAuth } from '../../context/AuthContext';

/** recent page -> showing all recents translion */
const RecentTranslation = () => {
    const navigate = useNavigate();
    const { portalId } = useAuth();
    const [page, setPage] = useState(1);
    const [loading, setLoading] = useState(false);
    const [translationData, setTranslationData] = useState([]);
    const [paginationData, setPaginationData] = useState({});
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [token, setAccessToken] = useState(null)
    const accessToken = localStorage.getItem('driveAccessToken') || null;
    const [showLoader, setShowLoader] = useState(false);

    const dispatch = useDispatch();

    const onSuccess = (data) => {
        setTranslationData(data.data.data.translationJobs);
        setPaginationData(data.data.data.pagination);
        setLoading(false);
    };
    const onError = (data) => {
        errorToast(data.data.message);
    };

    useEffect(() => {
        setLoading(true);
        dispatch(recentTranslationsAction({ page, page_size: rowsPerPage }, onSuccess, onError));
    }, [page, rowsPerPage]);

    const getLangName = (value) => {
        let label = null;
        availableLanguages.forEach((itemdata) => {
            if (itemdata.value === value) {
                label = itemdata.label;
            }
        });
        return label;
    };

    const getFileUrl = async (fileUrl) => {
        return new Promise((resolve, reject) => {
            dispatch(getSignedUrl(
                { fileUrl },
                (data) => resolve(data),
                (error) => reject(error)
            ));
        });
    };

    const onGetSuccess = (data) => {
        return data?.data?.data;
    };

    const onClickDownload = async (data, fileName) => {
        try {
            const response = await getFileUrl(data);
            const fileSignedUrl = onGetSuccess(response);

            if (fileSignedUrl) {
                // const link = document.createElement('a');
                // link.href = fileSignedUrl;
                // link.download = file_name;
                // document.body.appendChild(link);
                // link.click();
                // document.body.removeChild(link);
                const response = await fetch(fileSignedUrl);
                const blob = await response.blob();
                saveAs(blob, fileName);
            }
        } catch (error) {
            errorToast("Unable to Download File");
        }
    };

    const onClickPreview = (id) => {
        navigate(`/preview-doc/${id}`)
    }

    useEffect(() => {
        if (localStorage.getItem('logout') === 'true') {
            navigate(`/login/${portalId}`)
        }
    }, [])

    const uploadFileToGoogleDrive = async (translatedDataUrl, file_name) => {
        try {
            // Fetch the signed URL for the file
            const response = await getFileUrl(translatedDataUrl);
            const fileSignedUrl = onGetSuccess(response);

            if (fileSignedUrl) {
                // Fetch the file using the signed URL
                const fileResponse = await fetch(fileSignedUrl);
                const fileBlob = await fileResponse.blob();

                // Prepare the metadata and form data for the Google Drive API
                const metadata = {
                    name: file_name || 'download', // Use provided file name or default to 'download'
                    mimeType: fileBlob.type,
                };

                const formData = new FormData();
                formData.append(
                    "metadata",
                    new Blob([JSON.stringify(metadata)], { type: "application/json" })
                );
                formData.append("file", fileBlob);

                // Upload the file to Google Drive
                const uploadResponse = await fetch(
                    "https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart&fields=id",
                    {
                        method: "POST",
                        headers: new Headers({
                            Authorization: `Bearer ${accessToken}`, // Make sure accessToken is defined and valid
                        }),
                        body: formData,
                    }
                );

                const uploadResult = await uploadResponse.json();

                if (uploadResponse.ok) {
                    console.log("File uploaded successfully. File ID:", uploadResult.id);
                    setShowLoader(false);
                    successToast("File Exported Successfully");
                } else {
                    console.error("Error uploading file:", uploadResult.error);
                    setShowLoader(false);
                    errorToast('Unable to export file. Please try again later.');
                }
            } else {
                console.error("Failed to retrieve the signed URL.");
                setShowLoader(false);
                errorToast('Unable to export file. Please try again later.');
            }
        } catch (error) {
            console.error("An error occurred during the file upload:", error);
            setShowLoader(false);
            errorToast('Unable to export file. Please try again later.');
        }
    };

    return (
        <TranslationLayout>
            <Container className="recents mx-3 mb-1 overflow-auto" style={{ height: '90vh' }}>
                <p className='text-danger pt-2 text-start'><span className='fs_14 fw_600'>DISCLAIMER :</span>  At the end of the retention period, all data associated with the translation job will be deleted on the portal.
                    Users are advised to back up their files before the retention period expires to avoid any risk of data loss.</p>
                <div className="overflow-auto pt-1" style={{ height: '32rem' }}>
                    <table className="resource-table fs_13 mb-3">
                        <thead>
                            <tr>
                                <th width={"20%"}>Name</th>
                                <th width={"10%"}>Status</th>
                                <th width={"10%"}>Translated From</th>
                                <th width={"10%"}>Translated To</th>
                                <th width={"10%"}>Translated Date</th>
                                <th width={"5%"}>Pages</th>
                                <th width={"10%"}>Glossary</th>
                                <th width={"10%"} className="text-nowrap">Retention Days Left</th>
                                <th width={'20%'} className="text-center text-nowrap">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {loading ? (
                                <tr>
                                    <td colSpan="9">
                                        <Loading
                                            text={"Loading contents"}
                                            style={{ height: "5rem" }}
                                        />
                                    </td>
                                </tr>
                            ) : translationData?.length > 0 ? (
                                translationData.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>
                                            {(() => {
                                                const fileName = item?.file_name || "";
                                                const lastDot = fileName.lastIndexOf(".");

                                                if (lastDot === -1) {
                                                    return `${fileName}_${getLangName(item?.target_lang)}`;
                                                }

                                                const name = fileName.substring(0, lastDot);
                                                const ext = fileName.substring(lastDot + 1);

                                                return `${name}_${getLangName(item?.target_lang)}.${ext}`;
                                            })()}
                                        </td>
                                        <td>{item?.status ? "SUCCEEDED" : "PENDING"}</td>
                                        <td>{getLangName(item?.source_lang)}</td>
                                        <td>{getLangName(item?.target_lang)}</td>
                                        <td>{moment(item?.createdAt).format('MM/DD/YY, hh:mm A')}</td>
                                        <td>{item?.no_of_pages}</td>
                                        <td>{item?.glossary?.name || "N/A"}</td>
                                        <td className={`${item?.remainingDays < 5 ? "text-danger" : ""}`}>{item?.remainingDays} Days</td>
                                        <td className="">
                                            <div className="mx-5 d-flex gap-5 justify-content-center align-items-center">
                                                <img src={downloadIcon} alt="download-icon" data-tooltip-id="downloadIcon" style={{ height: '18px' }} className="cursor_pointer"
                                                    // onClick={() => onClickDownload(item?.translated_url,)}
                                                    onClick={() => {
                                                        const fileName = item?.file_name || "download";
                                                        const lastDot = fileName.lastIndexOf(".");

                                                        let newFileName;

                                                        if (lastDot === -1) {
                                                            newFileName = `${fileName}_${getLangName(item?.target_lang)}`;
                                                        } else {
                                                            const name = fileName.substring(0, lastDot);
                                                            const ext = fileName.substring(lastDot + 1);
                                                            newFileName = `${name}_${getLangName(item?.target_lang)}.${ext}`;
                                                        }

                                                        onClickDownload(item?.translated_url, newFileName);
                                                    }}

                                                />
                                                <Tooltip id="downloadIcon" place="bottom" effect="solid" className="text-center" style={{ width: '80px' }}>
                                                    Download
                                                </Tooltip>
                                                <div className="cursor_pointer">
                                                    {!accessToken ?
                                                        <div data-tooltip-id="exportDrive">
                                                            <GoogleDrivePicker setAccessTokens={setAccessToken} type={"export"} />

                                                        </div>
                                                        :
                                                        <ImGoogleDrive data-tooltip-id="exportDrive"
                                                            onClick={() => {
                                                                setShowLoader(true);
                                                                const fileName = item?.file_name || "download";
                                                                const lastDot = fileName.lastIndexOf(".");

                                                                let newFileName;

                                                                if (lastDot === -1) {
                                                                    newFileName = `${fileName}_${getLangName(item?.target_lang)}`;
                                                                } else {
                                                                    const name = fileName.substring(0, lastDot);
                                                                    const ext = fileName.substring(lastDot + 1);
                                                                    newFileName = `${name}_${getLangName(item?.target_lang)}.${ext}`;
                                                                }

                                                                uploadFileToGoogleDrive(item?.translated_url, newFileName);
                                                            }}
                                                        />
                                                    }
                                                    <Tooltip id="exportDrive" place="bottom" effect="solid" className="text-center" style={{ width: '120px' }}>
                                                        Export To Drive
                                                    </Tooltip>

                                                </div>
                                                <img src={previewIcon} data-tooltip-id="preview" alt="preview-icon" style={{ height: '18px' }} className="cursor_pointer" onClick={() => onClickPreview(item?.id)} />
                                                <Tooltip id="preview" place="bottom" effect="solid" className="text-center" style={{ width: '80px' }}>
                                                    Preview
                                                </Tooltip>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="7">No Rows to display</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>

                {paginationData?.total > 10 ?
                    <div className="mt-3 d-flex justify-content-end mx-4">
                        <Pagination
                            data={paginationData}
                            nextFunc={() => {
                                setPage(page + 1);
                            }}
                            prevFunc={() => {
                                setPage(page - 1);
                            }}
                            setPageRowFunc={(value) => {
                                setPage(1);
                                setRowsPerPage(value);
                            }}
                        />
                    </div> : ""
                }
                <LoaderModal show={showLoader} handleClose={() => setShowLoader(!showLoader)} text="Exporting..." />
            </Container>
        </TranslationLayout >
    )
}

export default RecentTranslation